import { ScreeningExpandedStatusEnum } from '../models/screening-expanded-status.enum';

export function mapScreeningExpandedStatusEnum(val?: ScreeningExpandedStatusEnum | number | null): ScreeningExpandedStatusEnum | null {
  if (typeof val === 'number') {
    switch (val) {
      case 10:
        return ScreeningExpandedStatusEnum.Unanswered;
      case 11:
        return ScreeningExpandedStatusEnum.UnansweredFirstReminderMailSent;
      case 12:
        return ScreeningExpandedStatusEnum.UnansweredSecondReminderMailSent;
      case 13:
        return ScreeningExpandedStatusEnum.UnansweredRemindersStopped;
      case 14:
        return ScreeningExpandedStatusEnum.UnansweredCancelWarningSent;
      case 20:
        return ScreeningExpandedStatusEnum.ReadyForProcess;
      case 25:
        return ScreeningExpandedStatusEnum.InsufficientResponse;
      case 30:
        return ScreeningExpandedStatusEnum.AssignedToSubcontractor;
      case 40:
        return ScreeningExpandedStatusEnum.ApprovedBySubContractor;
      case 50:
        return ScreeningExpandedStatusEnum.Installed;
      default:
        return null;
    }
  } else if (typeof val === 'string') {
    return isValidScreeningExpandedStatus(val) ? (val as ScreeningExpandedStatusEnum) : null;
  } else {
    return null;
  }
}

const isValidScreeningExpandedStatus = (status: string): boolean => {
  return Object.values(ScreeningExpandedStatusEnum).includes(status as ScreeningExpandedStatusEnum);
};
